import { APP_INITIALIZER, InjectionToken } from '@angular/core';
import { ConfigLoaderService } from '@core/config-angular';
import type { RudderAnalytics } from '@rudderstack/analytics-js/*';

import { JourneyAnalyticsLoader } from './journey-analytics-loader.service';

export const JOURNEY_ANALYTICS = new InjectionToken<RudderAnalytics>(
  'Journey Analytics'
);

function journeyAnalyticsFactory(
  configLoader: ConfigLoaderService,
  analyticsLoader: JourneyAnalyticsLoader
): () => Promise<void> {
  return async () => {
    const config = await configLoader.getConfigAsync();
    await analyticsLoader.load(config);
  };
}

function implementationFactory(analyticsLoader: JourneyAnalyticsLoader) {
  const analytics = analyticsLoader.analyticsInstance();
  if (analytics === null) {
    throw new Error(
      `No analytics instance is available yet. This means the JOURNEY_ANALYTICS token is used before 'provideJourneyAnalytics' has been called. 
      Please add this provider to your main module / component before using the Injection Token.`
    );
  }
  return analytics.getImplementation();
}

/**
 * Provider that initializes the Journey Analytics instances and sets up the `JOURNEY_ANALYTICS` token.
 */
export const provideJourneyAnalytics = () => [
  {
    provide: APP_INITIALIZER,
    useFactory: journeyAnalyticsFactory,
    deps: [ConfigLoaderService, JourneyAnalyticsLoader],
    multi: true,
  },
  {
    provide: JOURNEY_ANALYTICS,
    useFactory: implementationFactory,
    deps: [JourneyAnalyticsLoader],
  },
];
